import './Shop.scss';
import { UpgradeToPremium } from './UpgradeToPremium/UpgradeToPremium';
import { Certificates } from './Certificates/Certificates';
import { CertificatesFAQ } from '../../../components/CertificatesFAQ/CertificatesFAQ';
import { useEffect } from 'react';
import { useCartStore } from 'stores/Webshop/CartStore';
import { CartItem } from 'types/cart';
import { useTranslation } from 'react-i18next';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { CartButton } from './CartButton/CartButton';
import { useIsUserMember } from 'queryHooks/permissions';

export const Shop = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('Webshop', { ns: 'general' }),
  });
  const { data, isPending } = useIsUserMember();

  const addItemToCart = useCartStore((state) => state.addItemToCart);
  const setInitialized = useCartStore((state) => state.setInitialized);
  const initialized = useCartStore((state) => state.initialized);
  const itemsInCart: CartItem[] = useCartStore((state) => state.items);

  useEffect(() => {
    if (!initialized) {
      const cartFromLocalStorage = localStorage.getItem('cart');
      if (cartFromLocalStorage) {
        const parsedCart = JSON.parse(cartFromLocalStorage);
        parsedCart.items.forEach((item: CartItem) => addItemToCart(item));
      }
      setInitialized(true);
    }
  }, [initialized, addItemToCart, setInitialized]);

  return (
    <>
      {!isPending ? (
        <>
          <div>
            <div className='default-page-header shop-header'>
              <div>
                <h1 className='page-title'>{t('Webshop', { ns: 'general' })}</h1>
                <span className='page-subtitle'>{t('Description', { ns: 'webshop' })}</span>
              </div>

              {itemsInCart.length > 0 ? <CartButton /> : null}
            </div>
            {data ? null : <UpgradeToPremium />}
            <Certificates />
            <CertificatesFAQ />
          </div>
        </>
      ) : null}
    </>
  );
};
